import { useTranslator } from '@gandi/translate';
import { ContentBlock } from './ContentBlock';
import { jsx as _jsx } from "react/jsx-runtime";
export function DomainBlock() {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsx(ContentBlock, {
    productType: "domain",
    buttonUrl: "/domain/suggest",
    buttonText: __('Find my domain'),
    children: /*#__PURE__*/_jsx("p", {
      children: __('Our domain names are secure and protect your identity.')
    })
  });
}